export default "__VITE_ASSET__18921c3d__"